<template>
  <div class="TableBase2">
    <br>

    <v-data-table
      dense
      :headers="headers"
      :items="dataVals"
      :search="search"
      no-results-text="No se encontro el término buscado"
      no-data-text="No hay datos disponibles"
      multi-sort
      disable-initial-sort
      class="elevation-1"
      loading="Cargando... Por favor espere."
      rows-per-page-text="Filas por página:"
      :pagination.sync ="propiedades_table"

    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.value"
            @click="changeSort(header.value)"
            :class="['column sortable', propiedades_table.descending ? 'desc' : 'asc', header.value === propiedades_table.sortBy ? 'active' : '']"
            >

            <v-layout row wrap>
              <v-flex xs10>
                <template v-if="header.text.length <30">

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on"> {{ header.text }}</span>
                    </template>
                    <span> {{ header.text }}</span>
                      <span> {{ header.value }}</span>
                   </v-tooltip>
                </template>
                <template v-else>
                   <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ header.value }}</span>
                    </template>
                    <span>  {{ header.text }}</span>
                </v-tooltip>
                </template>

              </v-flex>
              <v-flex xs2>
               <v-icon small>arrow_upward</v-icon>
              </v-flex>
            </v-layout>

          </th>
        </tr>
      </template>

     <template slot="items" slot-scope="props">
        <td
          v-for="col in columns"
          :key="col.value"
          :align="align(props.item[col])"

        >
          <template v-if="props.item[col] != null">
            <template v-if="(props.item[col])==='Y'">
              <h2 class="red--text text--darken-3">SI</h2>
            </template>
            <template v-else>
              {{ props.item[col] }}
            </template>
          </template>
          <template v-else>
            -
          </template>
        </td>

      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'TableBaseCovid2',

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Cabecera de la tabla */
    headers: {
      type: Array,
      required: true
    },
    /** Contenido de la tabla */
    dataVals: {
      type: Array,
      required: true
    },
    /** Desarrolla la busqueda dentro de la tabla */
    search: {
      type: String,
      required: false
    },
    modo: {
      type: String,
      required: false
    }
  },

  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      // search: '',
      propiedades_table: {
        descending: true,
        page: 1,
        rowsPerPage: 25, // -1 for All",
        sortBy: 'Fecha',
        width: '50%'
        // totalItems: number"
      },

      backConf: {
        pathSupervisor: '/projects/covid/supervisor/',
        pathEvolucion: '/projects/covid/evoluciones/',
        page: 1
      },

      supervisorName: null,
      supervisorEmpresa: null,

      dialog_historia_clinica: false,
      h_clinica_paciente: null,
      h_clinica_idx: null,
      h_clinica_rx: null,
      fecha: null,

      evaluaciones: [],
      cargando_evaluacion: true,
      sin_evaluacion: false,
      rowsPerPageItems: [5, 10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]
    }
  },

  computed: {
    /**
     * Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []

      this.headers.forEach(function (element) {
        // console.log(element)
        colVals.push(element.value)
      })

      return colVals
    }
  },

  methods: {
    /**
     * Determina la alineación de la celda, si es string se alinea a la izquierda
     * para los demas casos se alinea a la derecha
     * @param  {string} val El valor a evaluar
     * @return {string}      La alineación a usar
     */
    align (val) {
      let algn = 'right'
      let type = typeof val

      switch (type) {
        case 'string':
          if (val[val.length - 1] === '%' || val[val.length - 2] === '.') {
            algn = 'center'
          } else {
            algn = 'center'
          }
          break
        case 'number':
          algn = 'left'
          break
        default:
          algn = 'center'
      }

      return algn
    },

    /**
     * funcion para Abrir en una pestaña nueva
     * La ficha Personal del reporte medico
     * @param  {string} c cedula de la ficha personal
     */
    openLink (c) {
      this.$router.push({
        name: 'FichaPersonal',
        params: {
          cc: c
        }
      })
    },

    searchSupervisor (c) {
      this.search = c
      this.supervisorName = null
      this.supervisorEmpresa = null

      let request = {
        method: 'get',
        url: this.backConf.pathSupervisor,
        params: {
          operativo: this.operativo,
          supervisor: c

        }
      }

      let t = this
      this.$store.dispatch('request_back', request)

        .then(function (resp) {
          // console.log(resp.data)
          t.supervisorName = (resp.data.Nombre)
          t.supervisorEmpresa = (resp.data.Empresa)
        })
        .catch(err => console.error(err))
    },

    getEvolucion (fecha) {
      this.dialog_historia_clinica = true
      this.fecha = fecha.substr(0, 10)
      this.evaluaciones = []
      this.cargando_evaluacion = true
      let request = {
        method: 'get',
        url: this.backConf.pathEvolucion,
        params: {
          op: this.operativo,
          fecha: fecha,
          paciente: this.cedula
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)

        .then(function (resp) {
          let data = resp.data.results
          let arr = []

          if (resp.data.count > 0) {
            for (const e in data) {
              let dicc = {
                'id': e,
                'h_clinica_paciente': data[e].cuadro_clinico,
                'h_clinica_idx': data[e].impresion,
                'h_clinica_rx': data[e].recomendaciones,
                'fecha': data[e].fecha.substr(11, 8),
                'medico': data[e].usuario
              }
              arr.push(dicc)
            }

            t.evaluaciones = arr
            t.cargando_evaluacion = false
          } else {
            t.cargando_evaluacion = false
            t.sin_evaluacion = true
          }
        })
        .catch(err => console.error(err))
    },
    changeSort (column) {
      if (this.propiedades_table.sortBy === column) {
        this.propiedades_table.descending = !this.propiedades_table.descending
      } else {
        this.propiedades_table.sortBy = column
        this.propiedades_table.descending = false
      }
    }
  }
}
</script>
